
const PUBLIC_ROUTE_URL = `${process.env.PUBLIC_URL}`;
export const USERROUTES = {
    USERLOGIN: PUBLIC_ROUTE_URL + "/user-login",
    USEROTP: PUBLIC_ROUTE_URL + "/user-otp",
    USERPROFILEINTRODUCTION: PUBLIC_ROUTE_URL + "/userprofileintroduction",
    NEWUSERPAGE: PUBLIC_ROUTE_URL + "/user-assessment",
    TESTCOMPLETE: PUBLIC_ROUTE_URL + "/test-complete",
    USERPROFILE: PUBLIC_ROUTE_URL + "/user-profile",
    PREVIEWALLANS: PUBLIC_ROUTE_URL + "/all-ans",
    lATESTPAGE: PUBLIC_ROUTE_URL + "/assesment",
}